<template>
  <BasicPoster @initializedUser="initPoster">
    <div :class="['detail', { 'p-detail': type !== 'poster' }]">
      <div class="user">
        <img class="user-avatar" :src="userInfo.userAvatarImg" />
        <div class="user-detail">
          <span class="user-name">{{ username }}</span>
          <span style="font-weight: normal">{{ clockInTitleText }}</span>
        </div>
      </div>
      <div class="progress-container">
        <template v-for="(item, index) in clockInStores">
          <div class="progress" :key="item.categoryId">
            <span>{{ item.categoryDesc }}</span>
            <div class="progress-bar-container">
              <div class="progress-bar-icon">
                <img :src="progressBarIcons[index]" />
              </div>
              <div class="progress-bar">
                <div :style="progressBarStyle[index]">
                  <span :style="progressBarSpanStyle[index]">{{ item.count }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="map">
        <img class="map-img" :src="bgMapImg" />
        <img
          v-for="cityInfo in citiesInfo"
          :key="cityInfo.id"
          :style="{ top: cityInfo.top + 'rem', left: cityInfo.left + 'rem', transform: 'scale(' + cityInfo.scale + ')' }"
          class="flag"
          src="@/assets/images/icon_flag.png"
        />
      </div>
      <div class="tips">
        {{ clockInFeatsText[0] }}
        <span>{{ rankRate + "%" }}</span>
        {{ clockInFeatsText.length >= 2 ? clockInFeatsText[1] : "" }}
      </div>
      <div class="qrcode-container">
        <img class="qrcode-img" :src="qrcodeUrl" />
        <span>扫码查看我的成绩</span>
      </div>
    </div>
  </BasicPoster>
</template>

<script>
import BasicPoster from '../BasicPoster'
import { mapGetters, mapMutations } from 'vuex'
import { qrcanvas } from 'qrcanvas'
import { loadImg } from '../../../../utils/loadImg'
import logo from '@/assets/images/logo.png'
import substring, { getStrLen } from '../../../../utils/substring'
import { citiesInfo, getFlagsLocation } from '../../../../utils/getFlagsLocation'
import { getMyClockIn, getRecordById } from '../../../../server/interfaces'
import { getBase64Img, getBase64ImgArr } from '../../../../utils/getBase64Image'
import { initShare } from '../../../../utils/share'
const bgMap = require('../../../../assets/images/bg_map.png')

export default {
  name: 'AchievementPoster',
  props: {
    type: {
      type: String,
      default: '' // "" | "poster"
    }
  },
  components: { BasicPoster },
  data () {
    return {
      siteProgressBarWidth: '',
      antiqueProgressBarWidth: '',
      qrcodeUrl: '',
      citiesInfo: citiesInfo,
      clockInStores: [],
      rankRate: 0,
      progressBarIcons: [],
      recordId: '',
      userName: '',
      bgMapImg: ''
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    ...mapGetters('activityInfo', ['activityInfo', 'activityId']),
    username () {
      return getStrLen(this.userName) > 20 ? substring(this.userName, 9) : this.userName
    },
    clockInText () {
      return this.activityInfo?.mapStyle?.clockInText
    },
    clockInTitleText () {
      const clockInTitleText = this.clockInText?.clockInTitleText
      return /X+/i.test(clockInTitleText) ? clockInTitleText?.match(/X+(.*)/i)?.[1] : clockInTitleText
    },
    clockInFeatsText () {
      const clockInFeatsText = this.clockInText?.clockInFeatsText
      const text = clockInFeatsText?.match(/(.*?)X+(.*)/i)
      return /X+/i.test(clockInFeatsText) ? [text[1], text[2]] : [clockInFeatsText]
    },
    progressBarStyle () {
      return this.clockInStores.map(item => {
        let num = item.count / item.storeNum
        const progress = 0.15 + item.count.toString().length * 0.05
        num = num > progress ? num : progress
        return { width: (num * 100).toFixed(0) + '%' }
      })
    },
    progressBarSpanStyle () {
      return this.clockInStores.map(item => {
        const width = item.count / item.storeNum
        const left = 0.22 + item.count.toString().length * 0.05
        return width > left ? {} : { left: (left * 2.1).toFixed(2) + 'rem' }
      })
    },
    shareDesc () {
      return `我打卡了${this.clockInStores.map(record => `${record.count}个${record.categoryName}`).join('，')}，已超过${
        this.rankRate
      }%的用户`
    }
  },
  watch: {
    type: {
      handler () {
        this.$nextTick(() => {
          this.initPoster()
        })
      }
    }
  },
  methods: {
    ...mapMutations({
      showLoading: 'loading/showLoading'
    }),
    async initPoster () {
      await this.getMyClockIn()
      let url = window.location.origin + window.location.pathname + bgMap
      if (process.env.VUE_APP_RUN_ENV === 'dev') {
        url = 'https://teststatic.nfapp.southcn.com/hd/gd-red-map/img/bg_map.807172a7.png'
      }
      const [bgMapImg] = await Promise.all([getBase64Img(url), this.getQrcodeUrl()])
      this.bgMapImg = bgMapImg
      this.showLoading('海报生成中...')
      try {
        initShare({
          shareTitle: `${this.activityInfo.name}-${this.username}的打卡成绩`,
          shareUrl:
            window.location.origin +
            window.location.pathname +
            this.$router.resolve({ path: '/clockIn/achievement', query: { id: this.activityId, rid: this.recordId } }).href,
          shareIcon: this.activityInfo.share.shareIcon,
          shareDesc: this.shareDesc
        })
      } catch (e) {
        window.console.log(e)
      }
      await this.$nextTick()
      if (this.activityId) {
        this.$emit('initialized')
      } else {
        const unwatch = this.$watch(
          'activityId',
          id => {
            if (id) {
              this.$emit('initialized')
              unwatch && unwatch()
            }
          },
          { immediate: true }
        )
      }
    },
    async getMyClockIn () {
      const recordId = this.$route.query.rid
      const { id, cityCode, clockInStores, rankRate, userName } = await (recordId
        ? getRecordById(recordId)
        : getMyClockIn({ activityId: this.activityId }))
      this.userName = userName || this.userInfo.userName
      const imgArr = clockInStores?.map(item => item?.icon) || []
      this.recordId = id || ''
      this.progressBarIcons = await getBase64ImgArr(imgArr)
      this.rankRate = rankRate ? (rankRate * 100).toString().slice(0, 4) : 0
      this.clockInStores = clockInStores || []
      this.getFlagsLocation(cityCode || [])
    },
    async getQrcodeUrl () {
      const url = window.location.origin + window.location.pathname
      const image = await loadImg(url + logo)
      const canvas = qrcanvas({
        data: decodeURIComponent(url + this.$router.resolve({ path: '/', query: { id: this.activityId } }).href),
        padding: 5,
        size: 130,
        logo: {
          image
        }
      })
      this.qrcodeUrl = canvas.toDataURL('image/png')
    },
    getFlagsLocation (locations = []) {
      this.citiesInfo = getFlagsLocation(locations)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail {
  padding: 0.6rem 0.4rem 0.6rem 0.5rem;
  position: relative;
  height: 100%;

  .user {
    display: flex;
    font-size: 0.32rem;
    font-weight: bold;
    color: #151515;

    .user-avatar {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      border: 0.04rem solid #ffffff;
      vertical-align: middle;
    }

    .user-detail {
      text-align: left;
      line-height: 0.52rem;
      margin-left: 0.2rem;
      word-break: break-all;
    }

    .user-name {
      display: inline-block;
      color: #c41b1b;
      padding-right: 0.2rem;
      max-width: 3.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
  }

  .progress-container {
    margin-top: 0.29rem;

    .progress {
      height: 0.77rem;
      display: flex;
      align-items: center;
      overflow: hidden;

      & > span {
        color: #b23f00;
        font-size: 0.3rem;
      }

      .progress-bar-container {
        flex: 1;
        display: flex;
        position: relative;

        .progress-bar-icon {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 99;
          left: 0;
          width: 0.77rem;
          height: 0.58rem;

          & > img {
            height: 100%;
            object-fit: contain;
          }
        }

        .progress-bar {
          display: flex;
          position: relative;
          width: 100%;
          height: 0.34rem;
          margin-left: 0.2rem;
          border-radius: 0.17rem;
          background-color: #ffc58a;
          overflow: hidden;

          & > div {
            position: relative;
            height: 0.34rem;
            border-radius: 0.17rem;
            background-image: linear-gradient(270deg, #ff3232 0%, #ffc35f 100%);
          }

          span {
            position: absolute;
            right: 0.14rem;
            color: #ffffff;
            font-size: 0.28rem;
            line-height: 0.34rem;
          }
        }
      }
    }
  }

  .map {
    height: 3.33rem;
    width: 4.6rem;
    margin-top: 0.3rem;
    position: relative;

    .map-img {
      width: 4.6rem;
      height: 3.33rem;
    }

    .flag {
      position: absolute;
      height: 0.5rem;
      transform-origin: 35% 85%;
    }
  }

  .tips {
    color: #c41b1b;
    font-size: 0.28rem;
    padding-left: 0.28rem;
    margin-top: 0.25rem;
    text-align: left;

    span {
      font-size: 0.34rem;
      font-weight: bold;
    }
  }

  .qrcode-container {
    box-sizing: border-box;
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 0.22rem;
    line-height: 0.34rem;
    color: #b91f1a;
    background-color: #ffc58a;
    border-radius: 0.2rem 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.16rem 0.1rem 0.1rem 0.1rem;

    .qrcode-img {
      width: 1.3rem;
      height: 1.3rem;
      padding-bottom: 0.05rem;
    }
  }
}

.p-detail {
  padding-top: 0.63rem;

  .progress-container {
    margin-top: 0.35rem;
  }

  .map {
    margin: 0.35rem auto 0;
  }

  .tips {
    position: absolute;
    left: 1.58rem;
    bottom: 0.72rem;
  }

  .qrcode-container {
    display: none;
  }
}
</style>
